var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { List } from 'immutable';
import { cssClassMap } from '../../../constants/SportCssMap';
import { matchStartDateSortFunc } from '../../../rendering-commons/Sorting';
import MatchesGroup from './MatchesGroup';
function filterMatches(matches, filter) {
    if (filter === null || filter === undefined || filter === 0) {
        return matches;
    }
    var date = new Date();
    var dateFilter = new Date(date.getTime() + filter * 60 * 60 * 1000);
    return matches.filter(function (m) { return m.get('startDate') <= dateFilter; });
}
function saveToStorage(leagueId) {
    if (localStorage.getItem('expandedLeagues')) {
        var leagues = JSON.parse(localStorage.getItem('expandedLeagues'));
        if (leagues.find(function (l) { return +l === leagueId; })) {
            leagues.splice(leagues.findIndex(function (l) { return l === leagueId; }), 1);
        }
        else {
            leagues.push(leagueId);
        }
        localStorage.setItem('expandedLeagues', JSON.stringify(leagues));
    }
    else {
        var leagues = [leagueId];
        localStorage.setItem('expandedLeagues', JSON.stringify(leagues));
    }
}
function loadFromStorage(leagueId) {
    if (localStorage.getItem('expandedLeagues')) {
        var leagues = JSON.parse(localStorage.getItem('expandedLeagues'));
        return leagues.find(function (l) { return +l === leagueId; });
    }
}
var League = /** @class */ (function (_super) {
    __extends(League, _super);
    function League() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            headerToggled: _this.props.expandedLeague || loadFromStorage(_this.props.league.get('id'))
        };
        _this.toggleHeader = function () {
            _this.setState({
                headerToggled: !_this.state.headerToggled
            });
            saveToStorage(_this.props.league.get('id'));
        };
        return _this;
    }
    League.prototype.render = function () {
        var _a = this.props, league = _a.league, matches = _a.matches, section = _a.section, languageId = _a.languageId, expandedLeague = _a.expandedLeague, gridLocalization = _a.gridLocalization, filterType = _a.filterType;
        var headerToggled = this.state.headerToggled;
        var leagueMatchesIds = league.get('matches');
        var leagueMatches = leagueMatchesIds.map(function (m) { return matches.get(m); });
        leagueMatches = filterMatches(leagueMatches, filterType);
        if (leagueMatches.size === 0) {
            return false;
        }
        var blcCls = headerToggled ? 'blc blc_line selected' : 'blc blc_line';
        if (expandedLeague) {
            blcCls = 'blc blc_line selected';
        }
        var renderMainMatchesGroup = [];
        var renderSecondaryMatchesGroup = [];
        var timezone = moment.tz.guess();
        var mainLeagueMatches = new List();
        var secondaryLeagueMatches = new List();
        leagueMatches.forEach(function (m) {
            if (m.get('type') === 1) {
                mainLeagueMatches = mainLeagueMatches.push(m);
            }
            else {
                secondaryLeagueMatches = secondaryLeagueMatches.push(m);
            }
        });
        var sortedMainLeagueMatches = mainLeagueMatches
            .sort(matchStartDateSortFunc)
            .groupBy(function (m) { return m.get('startDate')
            .tz(timezone).format('MM-DD-YYYY'); });
        var sortedSecondaryLeagueMatches = secondaryLeagueMatches
            .sort(matchStartDateSortFunc)
            .groupBy(function (m) { return m.get('startDate')
            .tz(timezone).format('MM-DD-YYYY'); });
        var props = {
            languageId: languageId,
            section: section,
            sportId: league.get('sportId'),
            gridLocalization: gridLocalization
        };
        var i = 0;
        sortedMainLeagueMatches.forEach(function (mathches, mdate) {
            var matchIds = mathches.map(function (m) { return m.get('id'); });
            renderMainMatchesGroup.push(_jsx(MatchesGroup, __assign({ startDate: mdate, matchIds: matchIds }, props), ++i));
        });
        sortedSecondaryLeagueMatches.forEach(function (mathches, mdate) {
            var matchIds = mathches.map(function (m) { return m.get('id'); });
            var whoHigher = mathches.first().get('type') === 2;
            renderSecondaryMatchesGroup.push(_jsx(MatchesGroup, __assign({ startDate: mdate, matchIds: matchIds }, props, { whoHigher: whoHigher }), ++i));
        });
        return (_jsxs("div", __assign({ className: blcCls, id: "league-".concat(league.get('id')) }, { children: [_jsx("div", __assign({ className: 'header title toggle', onClick: this.toggleHeader }, { children: _jsx("div", __assign({ className: "name ".concat(cssClassMap[league.get('sportId')]) }, { children: league.get('name') })) })), headerToggled && _jsxs("div", __assign({ className: 'toggle_content' }, { children: [renderMainMatchesGroup, renderSecondaryMatchesGroup] }))] })));
    };
    League.propTypes = {
        gridLocalization: PropTypes.object.isRequired,
        expandedLeague: PropTypes.any,
        league: PropTypes.object.isRequired,
        section: PropTypes.string.isRequired,
        matches: PropTypes.object.isRequired,
        languageId: PropTypes.number.isRequired,
    };
    return League;
}(React.Component));
function mapStateToProps(state, props) {
    var id = props.id, section = props.section;
    var league = state.application.getIn([section, 'leagues', id]);
    var matches = state.application.getIn([section, 'matches']);
    var languageId = state.application.get('languageId');
    return {
        league: league,
        matches: matches,
        languageId: languageId
    };
}
League = connect(mapStateToProps)(League);
export default League;



// WEBPACK FOOTER //
// ./src/components/grid/sports/League.jsx